<script>
  // Heroicons 1.0.6, fast-forward. Similar current version: forward
  export let iconClass = '';
</script>

<svg xmlns="http://www.w3.org/2000/svg" class={iconClass} viewBox="0 0 20 20" fill="currentColor">
  <title>Next</title>
  <path d="M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0
    001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z"
    />
</svg>